import { useEffect, useRef } from 'react'

const useOutsideClick = (
  callback, // callback wykonany po kliknieciu poza obiekt,
  skipElementId, // callback nie jest wykonany jezeli klikniety element ma takie id,
) => {
  const ref = useRef()

  useEffect(() => {
    const handleClick = (event) => {
      if (
        ref.current &&
        !ref.current.contains(event.target) &&
        event.target.id !== skipElementId
      ) {
        callback(event)
      }
    }

    document.addEventListener('click', handleClick, true)

    return () => {
      document.removeEventListener('click', handleClick, true)
    }
  }, [ref, callback, skipElementId])

  return ref
}

export { useOutsideClick }
